{
  "title": "No pudimos encontrar la página",
  "body": "Por favor confirma si la URL que proporcionaste es correcta e intenta de nuevo"
}
